<template>
  <div class="AWS">
    <div class="AWS__header">
      <span>Input: S3 Upload File</span>
      <v-btn icon @click="extend = !extend"><v-icon> {{ extend ? 'mdi-chevron-up' : 'mdi-chevron-down' }} </v-icon></v-btn>
    </div>
    <div v-if="extend">
      <div v-if="isValidJson" class="AWS__body">
        <div>
          <p><span style="font-weight: bold">File Location: </span>{{ inputObject.bucket }}/{{ inputObject.folder }}</p>
          <p><span style="font-weight: bold">Type: </span>{{ inputObject.mimeType }}</p>
          <div style="margin-top: 20px" v-if="Object.keys(inputObject?.metadata)?.length > 0">
            <div style="margin-bottom: 10px">
              <p><span style="font-weight: bold">File Metadata:</span></p>
            </div>
            <p v-for="metadata in Object.keys(inputObject.metadata)" :key="metadata">
              <span style="font-weight: bold">{{ metadata }}: </span>{{ inputObject.metadata[metadata] }}
            </p>
          </div>
        </div>
        <json-viewer
            :expand-depth=0
            :value="inputObject"
            style="white-space: pre-line; border-radius: 15px; width: 100%"
        ></json-viewer>
      </div>
      <div v-if="!isValidJson" style="padding: 10px">
        <v-progress-circular
            :size="20"
            :width="1"
            color="primary"
            indeterminate
        />
      </div>
    </div>
  </div>
</template>

<script>
import 'vue-json-viewer/style.css';
import { helpers } from '@/mixins/helpers';
import VueLoaders from 'vue-loaders';

import JsonViewer from 'vue-json-viewer';
import Vue from "vue";

Vue.use(VueLoaders);

export default {
  name: 's3-upload-input',
  components: { JsonViewer },
  props: {
    input: {},
    name: {},
  },
  mixins: [helpers],
  data() {
    return {
      extend: false,
    };
  },
  computed: {
    inputObject() {
      return typeof this.input !== 'string' ? this.input : JSON.parse(this.input)
    },
    isValidJson() {
      try {
        if(typeof this.input !== 'string') {
          return true;
        }
        JSON.parse(this.input);
        return true
      } catch (e) {
        return false;
      }
    }
  },
  methods: {},
};
</script>

<style scoped lang="scss">
@import '../index';
</style>
